import { defineStore } from "pinia";
import piniaPersistConfig from "@/stores/helper/persist";

export const useUserStore = defineStore({
    id: "zhihao-user",
    state: (): { token: string } => ({
        token: ""
    }),
    getters: {},
    actions: {
        setToken(token: string) {
            this.token = token;
        }
    },
    persist: piniaPersistConfig("zhihao-user")
});
